import {Component} from '@angular/core';
/**
 * \@title Basic chips
 */
export class ChipsOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'chips-overview-example',
  templateUrl: 'chips-overview-example.html',
  styleUrls: ['chips-overview-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ChipsOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ChipsOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ChipsOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
